/* eslint-disable */

//tslint:disable

import { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api/shared/http';
import {
  TAddCallbackModel,
  IAddCallbackRequest,
  IMappers,
  IAddCallbackResponse,
  IAddCallbackResponseError,
  TAddCallbackResponse,
} from './types';

const defaultConfig: TAddCallbackModel = {
  apiType: 'public',
  assertStatusCodes: [200, 400],
  method: 'POST',
  microserviceName: 'newbuilding-calltracking',
  pathApi: '/v1/add-callback/',
  hostType: 'ud-api',
} as TAddCallbackModel;

function createAddCallbackModel(parameters: IAddCallbackRequest): TAddCallbackModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface IAddCallbackOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  parameters: IAddCallbackRequest;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
}

async function fetchAddCallback<TResponse200, TResponse400>({
  httpApi,
  parameters,
  config,
  mappers,
}: IAddCallbackOptions<TResponse200, TResponse400>): Promise<TResponse200 | TResponse400 | TAddCallbackResponse> {
  const { response, statusCode } = await httpApi.fetch(createAddCallbackModel(parameters), config);

  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IAddCallbackResponse);
    }

    if (statusCode === 400) {
      return mappers[400](response as IAddCallbackResponseError);
    }
  }

  return { response, statusCode } as TAddCallbackResponse;
}

export { defaultConfig, createAddCallbackModel, fetchAddCallback };
